<template>
    <form class="form settings" v-bind:action="apiUrl + '/settings'" v-on:submit.prevent="handleSubmit">
        <div class="form__group">
            <label class="form__label">{{ __('Recommended for you') }}</label>
            <textarea class="form__control has-background has-height-auto" autocomplete="off" rows="15"
                   v-model="recommendedForYou"
            />
            <span class="form__focus"></span>
        </div>

        <button class="btn is-primary is-pulled-right" type="submit">{{ __('Save') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                recommendedForYou: '',
                errors: {}
            }
        },
        methods: {
            getSettings: function () {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/settings').then(function (response) {
                    const settings = response.body.original;

                    settings.forEach(function(setting, key) {
                        this[setting.key] = setting.value;
                    }.bind(this));

                    eventBus.$emit('hide-loader');

                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleSubmit: function (e) {
                const form = e.target;
                const action = form.getAttribute('action');

                eventBus.$emit('show-loader');

                this.$http.post(action, {
                    recommendedForYou: this.recommendedForYou
                }).then(function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit('show-alert', 'success', this.__('Settings has been successfully saved.'));
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );

                    eventBus.$emit('hide-loader');
                }.bind(this));
            },
            init: function () {
                this.getSettings();
            }
        },
        mounted: function () {
            this.init();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Settings.vue